import React from "react";
import AppCheckboxComponent from "../../../components/form/app-checkbox";
import { Box } from "@material-ui/core";

const CheckboxesComponent = () => {
  return (
    <Box style={{ display: "flex", gap: "2rem", padding: "0 40px" }}>
      <AppCheckboxComponent label="Checkbox Medium" size="medium" />
      <AppCheckboxComponent label="Checkbox Small" size="small" />
    </Box>
  );
};

export default CheckboxesComponent;
